/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProductVariants = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 23H2v-6h6zm-4-2h2v-2H4zm11 2H9v-6h6zm-3-3h-1v1h1v-1h1v-1h-1zm10 3h-6v-6h6zm-4-11.586L14.414 15H5V5.586L8.586 2H18zM7 13h6V7H7zm8-6.586v5.172l1-1V5.414zM8.414 5h5.172l1-1H9.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgProductVariants as ProductVariants };
